import { goalInboxID, lifeAreaOtherID } from 'shared/types/orderable-section';
import { CreateTask, NewTask } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';

export const createTaskToNewTask = ({
  tagIds: _tagIds,
  ...task
}: CreateTask): NewTask => {
  const type = task.schedules?.length
    ? [TaskType.Habit, TaskType.Repeating].includes(task.type)
      ? task.type
      : TaskType.Repeating
    : TaskType.Task;

  return {
    ...task,
    type,
    hideOnTodo: type === TaskType.Habit ? task.hideOnTodo ?? null : null,
    goalId: task.goalId === goalInboxID ? null : task.goalId ?? null,
    lifeAreaId:
      task.lifeAreaId === lifeAreaOtherID ? null : task.lifeAreaId ?? null,
    startDate: new Date(),
    createdAt: new Date(),
    endStrategy: {
      deadline: task.endStrategy?.deadline ?? null,
      completionCount: task.endStrategy?.completionCount ?? null,
    },
  } as NewTask;
};
